export default __webpack_public_path__ + "static/media/deal.b71a933b.svg";